import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=146a039b&scoped=true&"
import script from "./DeviceType.vue?vue&type=script&lang=js&"
export * from "./DeviceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a039b",
  null
  
)

export default component.exports